module.exports = __webpack_public_path__ + "fonts/NunitoSans-Bold.c0bdbb5.woff2";